import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row } from 'antd';
import styles from './HomePage.scss';

// containers
import NotebooksContainer from '../../containers/NotebooksContainer/NotebooksContainer';

// action
import { switchDev } from '../../actions/GlobalAction';

// reducer
import { getState } from '../../reducers/Global/GlobalReducer';

// import TestI18N from '../../components/TestI18N/TestI18N';

@connect(
  state => ({
    isDev: getState(state).get('isDev'),
  }),
  dispatch => (bindActionCreators({ switchDev }, dispatch)),
)
export default class HomePage extends Component {
  componentDidMount() {
    window[Symbol.for('switchDev')] = this.props.switchDev;
  }

  render() {
    const { match, isDev } = this.props;
    return (
      <Row className={styles['home-page']}>
        {
          // isDev && <TestI18N/>
        }
        <Route path={match.path} component={NotebooksContainer}/>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomePage.js